import React from "react";
import { RowSelectionState, OnChangeFn } from "@tanstack/react-table";
// import { xor, map } from "lodash";
import { IItem } from "../types";

export type TUseTableRowSelectionReturn<TItem extends IItem> = {
    selectedItems: TItem[];
    rowSelection: RowSelectionState;
    onRowSelectionChange: OnChangeFn<RowSelectionState>;
};

const getSelectedItems = <TItem extends IItem>(items: TItem[], rowSelection: RowSelectionState): TItem[] => {
    return items.filter((_, index) => rowSelection[index.toString()]);
};

const useTableRowSelection = <TItem extends IItem>(
    items: TItem[],
    selectedItemsProp?: TItem[],
    onRowSelectionChangeProp?: (selectedItems: TItem[]) => void
): TUseTableRowSelectionReturn<TItem> => {
    const [rowSelection, setRowSelection] = React.useState<RowSelectionState>({});
    const onRowSelectionChange = React.useCallback<OnChangeFn<RowSelectionState>>(
        updaterOrValue => {
            const newState = typeof updaterOrValue === "function" ? updaterOrValue(rowSelection) : updaterOrValue;
            setRowSelection(newState);
            onRowSelectionChangeProp?.(getSelectedItems(items, newState));
        },
        [items, rowSelection, onRowSelectionChangeProp]
    );

    React.useEffect(() => {
        setRowSelection({});
    }, [items]);

    // React.useEffect(() => {
    //     const selectedItems = getSelectedItems(items, rowSelection);
    //     if (selectedItemsProp && xor(map(selectedItemsProp, "id"), map(selectedItems, "id")).length > 0) {
    //         const newSelection: RowSelectionState = {};
    //         items.forEach((item, index) => {
    //             newSelection[index.toString()] = selectedItemsProp.includes(item);
    //         });

    //         setRowSelection(newSelection);
    //     }
    // }, [items, selectedItemsProp]);

    const value = React.useMemo<TUseTableRowSelectionReturn<TItem>>(
        () => ({
            rowSelection,
            onRowSelectionChange,
            selectedItems: getSelectedItems(items, rowSelection)
        }),
        [rowSelection, onRowSelectionChange]
    );

    return value;
};

export default useTableRowSelection;
